const BASE_URL = process.env.COMCATE_API_URL;
const CRM_TOKEN = process.env.CRM_TOKEN;
export const ssoLogout = (SID, email, agencyId) => {
    return fetch(`${BASE_URL}/crm/${CRM_TOKEN}/sso/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify({ sid: SID, email: email, agencyId: agencyId })
    }).then(response => {
        if (response.status >= 200 && response.status <= 299) {
            return response.json();
        }
        else {
            response.json().then(res => {
                console.log(res, 'ssoLogout error response');
            });
            throw Error('Error occurred while logging user out with SID');
            // throw Error(response.statusText);
        }
    });
};
